import React, { useEffect, useState } from 'react';
import { Menu, X } from 'lucide-react';
import { AnimatePresence, motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { Logo } from './Logo';
import { DONATE_URL } from '../utils/donate';
export function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 20);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: 'Mission',
    href: '/#mission'
  }, {
    name: 'Commitments',
    href: '/#commitments'
  }, {
    name: 'Issues',
    href: '/#issues'
  }, {
    name: 'Coalition',
    href: '/#coalition'
  }, {
    name: 'Leadership',
    href: '/#leadership'
  }];
  return <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-pac-navy/95 backdrop-blur-md shadow-lg py-3' : 'bg-pac-navy py-5'}`} data-id="element-212" data-mp="1l1kl60pdjje4">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-213" data-mp="elzl0p056sof">
        <div className="flex justify-between items-center" data-id="element-214" data-mp="jmdtu99ki6ni">
          <Link to="/" className="flex items-center gap-2" aria-label="AZ City PAC home" data-id="element-215" data-mp="jkszokr60pq6">
            <Logo className="h-10 sm:h-12" data-id="element-216" data-mp="3n45h5acre2fd" />
          </Link>

          <nav className="hidden md:flex items-center gap-8" aria-label="Primary navigation" data-id="element-217" data-mp="3n1jare1ltsyq">
            {navLinks.map(link => <a key={link.name} href={link.href} className="text-sm font-medium text-slate-200 hover:text-white transition-colors uppercase tracking-wider" data-id="element-218" data-mp="ul36lhz0xiy">
                {link.name}
              </a>)}
            <Link to="/news" className="text-sm font-medium text-slate-200 hover:text-white transition-colors uppercase tracking-wider" data-id="element-219" data-mp="39axrho88nh0b">
              News
            </Link>
            <a href={DONATE_URL} target="_blank" rel="noopener noreferrer" className="bg-pac-red hover:bg-red-800 text-white px-6 py-2.5 rounded font-bold tracking-wider uppercase transition-all shadow-[0_0_15px_rgba(185,28,28,0.5)] hover:shadow-[0_0_25px_rgba(185,28,28,0.8)] transform hover:-translate-y-0.5 focus:outline-none focus:ring-2 focus:ring-pac-gold focus:ring-offset-2 focus:ring-offset-pac-navy" data-id="element-220" data-mp="2wbnfo3mqhdrl">
              Donate Now
            </a>
          </nav>

          <button type="button" className="md:hidden text-white p-2" onClick={() => setMobileMenuOpen(!mobileMenuOpen)} aria-label="Toggle menu" aria-expanded={mobileMenuOpen} data-id="element-221" data-mp="2nbi89thjifdf">
            {mobileMenuOpen ? <X className="h-6 w-6" data-id="element-222" data-mp="2ndpjaisukkp" /> : <Menu className="h-6 w-6" data-id="element-223" data-mp="a3r07d7mvqk9" />}
          </button>
        </div>
      </div>

      <AnimatePresence data-id="element-224" data-mp="f4wu3ed15jvd">
        {mobileMenuOpen && <motion.div initial={{
        opacity: 0,
        height: 0
      }} animate={{
        opacity: 1,
        height: 'auto'
      }} exit={{
        opacity: 0,
        height: 0
      }} className="md:hidden bg-pac-navy border-t border-slate-800 overflow-hidden" data-id="element-225" data-mp="143ysrewmkr7">
            <nav className="px-4 py-6 flex flex-col gap-4" aria-label="Mobile navigation" data-id="element-226" data-mp="xw7i9nrdfijk">
              {navLinks.map(link => <a key={link.name} href={link.href} onClick={() => setMobileMenuOpen(false)} className="text-lg font-medium text-slate-200 hover:text-white uppercase tracking-wider block py-2" data-id="element-227" data-mp="o2qq0o6vubi0">
                  {link.name}
                </a>)}
              <Link to="/news" onClick={() => setMobileMenuOpen(false)} className="text-lg font-medium text-slate-200 hover:text-white uppercase tracking-wider block py-2" data-id="element-228" data-mp="3k2b0cxegpe1w">
                News
              </Link>
              <a href={DONATE_URL} target="_blank" rel="noopener noreferrer" onClick={() => setMobileMenuOpen(false)} className="bg-pac-red text-white px-6 py-4 rounded font-bold tracking-wider uppercase text-center mt-4" data-id="element-229" data-mp="3b4igdfxspi86">
                Donate Now
              </a>
            </nav>
          </motion.div>}
      </AnimatePresence>
    </header>;
}